// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\PilotJobOrderDetails\PilotJobOrderDetailsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PilotJobOrderDetailsData is the class that PilotJobOrderDetails serializes to/from
export interface PilotJobOrderDetailsData {
    Id : number;
	
    PilotJobOrder : PilotJobOrderData | null;
	
    AssignablePilotIds : number[];
    CanAcknowledge : boolean;
    CanAddShift : boolean;
    CanAddShiphandlingNote : boolean;
    CanCancel : boolean;
    CanChangeVessel : boolean;
    CanDelete : boolean;
    CanEdit : boolean;
    CanEditBowThrusterOperational : boolean;
    CanEditDeepDraftConfirmed : boolean;
    CanEditDrafts : boolean;
    CanEditPortCall : boolean;
    CanEditServices : boolean;
    CanEditStartTimeConfirmed : boolean;
    CanEditTimes : boolean;
    CanEditVessel : boolean;
    CanManageBills : boolean;
    CanViewFullPilotAssignments : boolean;
}

// PilotJobOrderDetailsOptions is the class which may be passed to the PilotJobOrderDetails constructor to define optional initial data values
export interface PilotJobOrderDetailsOptions {
    Id : number;
	
    PilotJobOrder? : PilotJobOrderOptions | null;
	
    AssignablePilotIds? : number[];
    CanAcknowledge? : boolean;
    CanAddShift? : boolean;
    CanAddShiphandlingNote? : boolean;
    CanCancel? : boolean;
    CanChangeVessel? : boolean;
    CanDelete? : boolean;
    CanEdit? : boolean;
    CanEditBowThrusterOperational? : boolean;
    CanEditDeepDraftConfirmed? : boolean;
    CanEditDrafts? : boolean;
    CanEditPortCall? : boolean;
    CanEditServices? : boolean;
    CanEditStartTimeConfirmed? : boolean;
    CanEditTimes? : boolean;
    CanEditVessel? : boolean;
    CanManageBills? : boolean;
    CanViewFullPilotAssignments? : boolean;
}

export class PilotJobOrderDetails {
    public Id : DataSignal<number>;
	
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
	
    public AssignablePilotIds : SDataArray<number>;
    public CanAcknowledge : DataSignal<boolean>;
    public CanAddShift : DataSignal<boolean>;
    public CanAddShiphandlingNote : DataSignal<boolean>;
    public CanCancel : DataSignal<boolean>;
    public CanChangeVessel : DataSignal<boolean>;
    public CanDelete : DataSignal<boolean>;
    public CanEdit : DataSignal<boolean>;
    public CanEditBowThrusterOperational : DataSignal<boolean>;
    public CanEditDeepDraftConfirmed : DataSignal<boolean>;
    public CanEditDrafts : DataSignal<boolean>;
    public CanEditPortCall : DataSignal<boolean>;
    public CanEditServices : DataSignal<boolean>;
    public CanEditStartTimeConfirmed : DataSignal<boolean>;
    public CanEditTimes : DataSignal<boolean>;
    public CanEditVessel : DataSignal<boolean>;
    public CanManageBills : DataSignal<boolean>;
    public CanViewFullPilotAssignments : DataSignal<boolean>;

    constructor();
    constructor(data : PilotJobOrderDetailsOptions);
    constructor(data: PilotJobOrderDetailsOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
	    
        this.AssignablePilotIds = jsonableObservable(SArray<number>(data && data.AssignablePilotIds !== undefined ? data.AssignablePilotIds : []));
        this.CanAcknowledge = jsonableObservable(S.value<boolean>(data && data.CanAcknowledge !== undefined ? data.CanAcknowledge : false));
        this.CanAddShift = jsonableObservable(S.value<boolean>(data && data.CanAddShift !== undefined ? data.CanAddShift : false));
        this.CanAddShiphandlingNote = jsonableObservable(S.value<boolean>(data && data.CanAddShiphandlingNote !== undefined ? data.CanAddShiphandlingNote : false));
        this.CanCancel = jsonableObservable(S.value<boolean>(data && data.CanCancel !== undefined ? data.CanCancel : false));
        this.CanChangeVessel = jsonableObservable(S.value<boolean>(data && data.CanChangeVessel !== undefined ? data.CanChangeVessel : false));
        this.CanDelete = jsonableObservable(S.value<boolean>(data && data.CanDelete !== undefined ? data.CanDelete : false));
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanEditBowThrusterOperational = jsonableObservable(S.value<boolean>(data && data.CanEditBowThrusterOperational !== undefined ? data.CanEditBowThrusterOperational : false));
        this.CanEditDeepDraftConfirmed = jsonableObservable(S.value<boolean>(data && data.CanEditDeepDraftConfirmed !== undefined ? data.CanEditDeepDraftConfirmed : false));
        this.CanEditDrafts = jsonableObservable(S.value<boolean>(data && data.CanEditDrafts !== undefined ? data.CanEditDrafts : false));
        this.CanEditPortCall = jsonableObservable(S.value<boolean>(data && data.CanEditPortCall !== undefined ? data.CanEditPortCall : false));
        this.CanEditServices = jsonableObservable(S.value<boolean>(data && data.CanEditServices !== undefined ? data.CanEditServices : false));
        this.CanEditStartTimeConfirmed = jsonableObservable(S.value<boolean>(data && data.CanEditStartTimeConfirmed !== undefined ? data.CanEditStartTimeConfirmed : false));
        this.CanEditTimes = jsonableObservable(S.value<boolean>(data && data.CanEditTimes !== undefined ? data.CanEditTimes : false));
        this.CanEditVessel = jsonableObservable(S.value<boolean>(data && data.CanEditVessel !== undefined ? data.CanEditVessel : false));
        this.CanManageBills = jsonableObservable(S.value<boolean>(data && data.CanManageBills !== undefined ? data.CanManageBills : false));
        this.CanViewFullPilotAssignments = jsonableObservable(S.value<boolean>(data && data.CanViewFullPilotAssignments !== undefined ? data.CanViewFullPilotAssignments : false));
    }

    static key(obj : PilotJobOrderDetails) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotJobOrderDetailsOptions) {
        return obj.Id;
    }

    static update(obj : PilotJobOrderDetails, data : PilotJobOrderDetailsOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.AssignablePilotIds !== undefined) obj.AssignablePilotIds(data.AssignablePilotIds);
            if (data.CanAcknowledge !== undefined) obj.CanAcknowledge(data.CanAcknowledge);
            if (data.CanAddShift !== undefined) obj.CanAddShift(data.CanAddShift);
            if (data.CanAddShiphandlingNote !== undefined) obj.CanAddShiphandlingNote(data.CanAddShiphandlingNote);
            if (data.CanCancel !== undefined) obj.CanCancel(data.CanCancel);
            if (data.CanChangeVessel !== undefined) obj.CanChangeVessel(data.CanChangeVessel);
            if (data.CanDelete !== undefined) obj.CanDelete(data.CanDelete);
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
            if (data.CanEditBowThrusterOperational !== undefined) obj.CanEditBowThrusterOperational(data.CanEditBowThrusterOperational);
            if (data.CanEditDeepDraftConfirmed !== undefined) obj.CanEditDeepDraftConfirmed(data.CanEditDeepDraftConfirmed);
            if (data.CanEditDrafts !== undefined) obj.CanEditDrafts(data.CanEditDrafts);
            if (data.CanEditPortCall !== undefined) obj.CanEditPortCall(data.CanEditPortCall);
            if (data.CanEditServices !== undefined) obj.CanEditServices(data.CanEditServices);
            if (data.CanEditStartTimeConfirmed !== undefined) obj.CanEditStartTimeConfirmed(data.CanEditStartTimeConfirmed);
            if (data.CanEditTimes !== undefined) obj.CanEditTimes(data.CanEditTimes);
            if (data.CanEditVessel !== undefined) obj.CanEditVessel(data.CanEditVessel);
            if (data.CanManageBills !== undefined) obj.CanManageBills(data.CanManageBills);
            if (data.CanViewFullPilotAssignments !== undefined) obj.CanViewFullPilotAssignments(data.CanViewFullPilotAssignments);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderDetails.ts